// usePermissions.js - 權限 Hook
import { useMemo } from 'react';
import authService from '../services/authService';

/**
 * 權限 Hook - 用於 React 元件中檢查權限
 * @returns {Object} 權限檢查函式
 */
const usePermissions = () => {

    const permissions = useMemo(() => ({

        hasPermission: (permissionName) => authService.hasPermission(permissionName),
        hasFullPermission: (permissionName) => authService.hasFullPermission(permissionName),
        getScope: (permissionName) => authService.getPermissionScope(permissionName),
        getByCategory: (category) => authService.getPermissionsByCategory(category),
        hasRole: (roleName) => authService.hasRole(roleName),
        hasAllPermissions: (...permissionNames) => {
            return permissionNames.every(name => authService.hasPermission(name));
        },
        hasAnyPermission: (...permissionNames) => {
            return permissionNames.some(name => authService.hasPermission(name));
        },
        currentUser: authService.getCurrentUser(),
        debug: () => authService.debugPermissions(),


        quickCheck: {
            // Calendar 相關
            canViewCalendar: () => authService.hasPermission('Calendar.Read'),
            canEditCalendar: () => authService.hasPermission('Calendar.Edit'),

            // Listings 相關  
            canViewListings: () => authService.hasPermission('Listings.Read'),
            canViewPrices: () => authService.hasPermission('Listings.ViewPrices'),
            canEditPrices: () => authService.hasPermission('Listings.EditPrices'),

            // Users 相關
            canViewUsers: () => authService.hasPermission('Users.Read'),
            canEditUsers: () => authService.hasPermission('Users.Edit'),

            // Reports 相關
            canViewReports: () => authService.hasPermission('Reports.View'),
            canExportReports: () => authService.hasPermission('Reports.Export'),

            // 角色檢查
            isOwner: () => authService.hasRole('Owner') || authService.hasRole('OwnerWithEditPrices'),
            isAdmin: () => authService.hasRole('Admin'),
        }
    }), []);

    return permissions;
};

export default usePermissions;